namespace TabAurous.OMS {
    export interface DiscountingPolicyForm {
        Code: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Details: DiscountingPolicyDetailsEditor;
    }

    export class DiscountingPolicyForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.DiscountingPolicy';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DiscountingPolicyForm.init)  {
                DiscountingPolicyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = DiscountingPolicyDetailsEditor;

                Q.initFormType(DiscountingPolicyForm, [
                    'Code', w0,
                    'Name', w0,
                    'Details', w1
                ]);
            }
        }
    }
}
